import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: dialogueCard__container;
    position: relative;
    background-color: ${colours.background.SECTION};
    border-radius: 1.6rem;
  `,
  content: css`
    label: dialogueCard__content;
    padding: ${spacing.XS};

    > :last-child {
      margin-bottom: 0;
    }
  `,
  closeBase: css`
    label: dialogueCard__close;
    position: absolute;
    top: 1.8rem;
    right: ${spacing.XS};
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding: 0;
  `,
  closeDefaultExtras: css`
    color: ${colours.font.LIGHT_GRAY};
    border-radius: 50%;

    :hover,
    :focus {
      background-color: ${colours.background.GRAY};
    }

    :active {
      background-color: ${colours.font.ASSISTIVE};
    }
  `,
  closeIcon: css`
    label: dialogueCard__closeIcon;
    line-height: 0;
  `,
};

export default styles;
